import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Highlight } from './ui/Highlight';
export function Pricing() {
  return <Section className="text-center pb-32" id="precio" data-id="element-79">
      <div className="max-w-2xl mx-auto bg-surface border border-white/10 p-8 md:p-12 relative overflow-hidden group" data-id="element-80">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-81"></div>

        <h2 className="text-3xl md:text-4xl font-display font-bold mb-6" data-id="element-82">
          PRECIO ACCESIBLE. <br data-id="element-83" />
          EJECUCIÓN INMEDIATA.
        </h2>

        <p className="text-gray-400 mb-8 text-lg" data-id="element-84">
          Esto está diseñado para ser una compra impulsiva. Resultado medible:
          conversaciones reales con dueños reales.
        </p>

        <div className="mb-2" data-id="element-85">
          <span className="inline-block bg-red-600 text-white text-sm font-bold uppercase tracking-widest px-4 py-1.5 mb-4 animate-pulse" data-id="element-86">
            🔥 Descuento por Tiempo Limitado
          </span>
        </div>

        <div className="mb-10" data-id="element-87">
          <span className="text-2xl text-gray-500 line-through decoration-red-500/70 decoration-2 mr-3" data-id="element-88">
            $19.99
          </span>
          <span className="text-6xl font-display font-bold text-urgency" data-id="element-89">
            $6.39
          </span>
          <span className="text-gray-500 ml-2 text-xl" data-id="element-90">USD</span>
          <p className="text-red-400 text-sm font-semibold mt-2 tracking-wide" data-id="element-91">
            — Ahorras 68% hoy —
          </p>
        </div>

        <a href="https://everythingfouryou.com/cart/47956140359905:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-92">
          <Button variant="urgency" size="lg" fullWidth className="mb-6 text-lg uppercase tracking-wider" data-id="element-93">
            Descargar y Empezar Hoy
          </Button>
        </a>

        <p className="text-sm text-gray-500" data-id="element-94">
          Acceso inmediato al PDF + Recursos. Pago único.
        </p>
      </div>

      <div className="mt-20 max-w-2xl mx-auto" data-id="element-95">
        <h3 className="text-2xl font-bold mb-6" data-id="element-96">¿Sigues leyendo?</h3>
        <p className="text-xl text-gray-300 mb-8" data-id="element-97">
          Si llevas semanas "preparándote", esto es tu salida.
          <br data-id="element-98" />
          No más prompts guardados. No más "mañana empiezo".
        </p>
        <p className="text-primary font-bold text-xl" data-id="element-99">
          Tómalo y ejecútalo esta semana.
        </p>
      </div>
    </Section>;
}